import {Component} from '@angular/core';
import {NavController, AlertController, LoadingController} from 'ionic-angular';
import {SignInPage} from './../sign-in/sign-in';
import {AuthService} from './../../../services/auth';
import {SessionService} from '../../../services/session';
import {LocationsService} from '../../../services/locations';

@Component({
  selector: 'page-password',
  templateUrl: 'password.html'
})
export class PasswordPage {
  signInPage = SignInPage;

  email = '';

  constructor(public navCtrl: NavController,
              public authService: AuthService,
              public alertCtrl: AlertController,
              public loadingCtrl: LoadingController,
              public sessionService: SessionService,
              public locationsService: LocationsService) {
  }

  goToSignIn() {
    this.navCtrl.push(this.signInPage);
  }

  recoverPassword() {
    let loading = this.loadingCtrl.create({
      content: 'Reestableciendo contraseña...'
    });
    loading.present();
    this.authService.recoverPassword(this.email)
      .then(() => {
        loading.dismiss()
        let alert = this.alertCtrl.create({
          title: 'Éxito',
          subTitle: 'Se ha enviado un correo con las instrucciones para restablecer tu contraseña.',
        });
        alert.present();
      })
      .catch(err => {
        loading.dismiss()
        let alert = this.alertCtrl.create({
          title: 'Error',
          subTitle: this.locationsService.translate('pwError')
        });
        alert.present();
        this.sessionService.reportError(
          'passwordPage',
          'recoverPassword()',
          err,
          this.email
        );
      })
  }

  ionViewDidLoad() {
    window['page'] = 'PasswordPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/password/password.ts